export default {
  doctorInformation: JSON.parse(localStorage.getItem('doctorInformation')) || {},
  doctorMedicalLicenseStatus: '',
  loadedDoctorInformation: null,
  profile: {},
  originalProfile: {},
  loadDoctorProfileLoading: false,
  error: {},
  getDoctorProfileLoading: false,
  providerStatus: {},
  providerEmailValidation: {},
  modifyProfile: {}
}